// extracted by mini-css-extract-plugin
export default {"Tags":"Tags__Tags___aco_T","title":"Tags__title___QJC5Q","items":"Tags__items____NT_W","item":"Tags__item___o6kuB"};